import React, { useEffect, useState } from "react";
import KickImage from 'Reuseables/KickImage';
import Slider from "react-slick";
import { connect } from "react-redux";
import styled from "styled-components";
import { Link } from "react-router-dom";

import { getCloudImageUrl, normalizeBrand, emptyImage, formatCurrency } from "../../../utils";

import fireIcon from "../../../images/fire-product.png";
import ArrowPrev from "../../../images/arrow/luxury_prev.png";
import ArrowNext from "../../../images/arrow/luxury_next.png";

const PreviousArrow = (props) => {
  const { className, style, onClick, isLuxuryHotProducts } = props;
  const LeftArrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      width: 50px !important;
      height: 50px !important;
      object-fit: contain;
      box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.16);
      border-radius: 30px;
    }

    @media (max-width: 480px) {
      img {
        width: 40px !important;
        height: 40px !important;
        position: absolute;
        left: -50px;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage src={ArrowPrev} alt="..." />
    </LeftArrow>
  );
};

const TrendingPreviousArrow = (props) => {
  const { className, style, onClick, isLuxuryHotProducts } = props;
  const LeftArrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      width: 50px !important;
      height: 50px !important;
      object-fit: contain;
      box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.16);
      border-radius: 30px;
    }

    @media (max-width: 480px) {
      img {
        width: 40px !important;
        height: 40px !important;
        position: absolute;
        left: 10px;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage src={ArrowPrev} alt="..." />
    </LeftArrow>
  );
};

const NextArrow = (props) => {
  const { className, style, onClick, isLuxuryHotProducts } = props;
  const LeftArrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      width: 50px !important;
      height: 50px !important;
      object-fit: contain;
      box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.16);
      border-radius: 30px;
      right: -5px;
      position: absolute;
    }

    @media (max-width: 480px) {
      img {
        right: -50px;
        width: 40px !important;
        height: 40px !important;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage src={ArrowNext} alt="..." />
    </LeftArrow>
  );
};

const TrendingNextArrow = (props) => {
  const { className, style, onClick, isLuxuryHotProducts } = props;
  const LeftArrow = styled.div`
    &::before {
      content: "" !important;
    }
    img {
      width: 50px !important;
      height: 50px !important;
      object-fit: contain;
      box-shadow: 0 3px 7px 0 rgba(0, 0, 0, 0.16);
      border-radius: 30px;
      right: -5px;
      position: absolute;
    }

    @media (max-width: 480px) {
      img {
        right: 10px;
        width: 40px !important;
        height: 40px !important;
      }
    }
  `;
  return (
    <LeftArrow
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    >
      <KickImage src={ArrowNext} alt="..." />
    </LeftArrow>
  );
};

const openProductDetail = (id, category, slug, history) => {
  const categoryUrl =
    category === "apparels"
      ? "apparel"
      : category === "handbags"
        ? "luxury"
        : category;

  history.push(`${categoryUrl}/${id}/${slug}`);
};

const CarouselProduct = ({ dataProducts, history, isHotProducts, ratio, currency, isLuxuryHotProducts, isLuxuryTrendingNow }) => {

  const [settings, setSetting] = useState({
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: isHotProducts ? 3 : 4,
    slidesToScroll: 3,
    swipe: true,
    prevArrow: isLuxuryHotProducts ? <PreviousArrow /> : <TrendingPreviousArrow />,
    nextArrow: isLuxuryHotProducts ? <NextArrow /> : <TrendingNextArrow />,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  })

  return (
    <Slider className={isLuxuryHotProducts && "slider-luxury-hot"} {...settings}>
      {dataProducts.map((item, index) => {
        const category =
          (item.product.category && item.product.category.name) || "handbags";
        const img_url = item.product_variant_images.length
          ? getCloudImageUrl(item.product_variant_images[0].URL, 400)
          : emptyImage(category);
        const brandName = item.product && item.product.brand? (category === "lifestyles"? (item.product.brand.title? item.product.brand.title : item.product.brand.name) : item.product.brand.flat[0]) : "";

        return (
          <div className="product-item-wrapper">
            <div
              onClick={() =>
                openProductDetail(item.id, category, item.slug, history)
              }
              title={item.display_name}
              key={index}
              className={isLuxuryHotProducts ? "sneaker-item luxury-fire-product" : "sneaker-item"}
              style={{
                boxShadow: isHotProducts && "none",
                margin: isLuxuryTrendingNow && "10px"
              }}
            >
              <FireWrapper>
                {
                  item.editors_choice && (
                    <KickImage
                      alt={"Hot Product"}
                      src={fireIcon}
                      className="sneaker-item__hot-product"
                    />
                  )
                }
              </FireWrapper>
              <KickImage
                alt={item.display_name}
                src={img_url}
                className={`sneaker-item__image editors ${isLuxuryHotProducts ? "hot-products-slider" : null}`}
              />
              <div className="sneaker-item__text">
                <p>{brandName ? normalizeBrand(brandName) : null}</p>
                <p>{item.display_name}</p>
                <p>starts from</p>
                <p style={{ color: isHotProducts ? "red" : "#242424" }}>
                  {isHotProducts ? formatCurrency((item.latest_price.total_subsidy ? item.latest_price.total_subsidy : item.latest_price.asking_price), ratio, currency) : formatCurrency((item.price), ratio, currency)}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </Slider>
  )
}

const FireWrapper = styled.div`
  width: 20px;
  height: 20px;
  object-fit: contain;
  align-self: flex-end;
`

const mapStateToProps = state => ({
  ratio: state.dataAuth.userCurrency.ratio,
  currency: state.dataAuth.userCurrency.currency
})

export default connect(mapStateToProps)(CarouselProduct);